import { render, staticRenderFns } from "./PatentTechDistribution.vue?vue&type=template&id=4b1013e4&scoped=true"
import script from "./PatentTechDistribution.vue?vue&type=script&lang=js"
export * from "./PatentTechDistribution.vue?vue&type=script&lang=js"
import style0 from "./PatentTechDistribution.vue?vue&type=style&index=0&id=4b1013e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1013e4",
  null
  
)

export default component.exports